const FolderPermission = {
  READ: 1,
  DOWNLOAD: 2,
  WRITE: 4,
  DELETE: 8,
  ADMIN: 16
}
export default FolderPermission



// WEBPACK FOOTER //
// ./src/shared/utils/folderPermission.js